import { useFrame, useThree } from '@react-three/fiber'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import * as THREE from 'three'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(useGSAP)

// Proxy object — GSAP updates this, useFrame reads it every frame
const anim = {
  camX: 0, camY: 1, camZ: 4,
  targetX: 0, targetY: -0.5, targetZ: 0,
}

const targetVec = new THREE.Vector3()

export default function CameraAnimation() {
  const camera = useThree((state) => state.camera)

  // useFrame always applies values — no race condition with R3F
  useFrame(() => {
    camera.position.set(anim.camX, anim.camY, anim.camZ)
    targetVec.set(anim.targetX, anim.targetY, anim.targetZ)
    camera.lookAt(targetVec)
  })

  useGSAP(() => {
    // Intro animation (non-scroll, plays on load)
    // Scroll is blocked until this completes
    gsap.from(anim, {
      targetY: 4,
      targetZ: 3,
      ease: 'power1.inOut',
      duration: 3.5,
      onComplete: () => {
        // Unlock scroll after intro finishes
        if (window.__lenis) window.__lenis.start()
      },
    })

    // Single master timeline — one ScrollTrigger for entire scroll
    const master = gsap.timeline({
      scrollTrigger: {
        trigger: '.main-wrapper',
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1.5,
        invalidateOnRefresh: true,
      },
    })

    // Leg 1: Section 1 → Section 2 (time 0 to 1)
    master.to(anim, {
      camX: 2.56, camY: -1.01, camZ: 2,
      targetX: -4, targetY: 0, targetZ: 0,
      ease: 'none',
      duration: 1,
    }, 0)

    // Fade out section 1 (first 40% of leg 1)
    master.to('.section-1', {
      opacity: 0,
      ease: 'none',
      duration: 0.4,
    }, 0)

    // Leg 2: Section 2 → Section 3 (time 1 to 2)
    master.to(anim, {
      camX: 0, camY: -1.01, camZ: 5,
      targetX: 4, targetY: 0, targetZ: 0,
      ease: 'none',
      duration: 1,
    }, 1)
  }, [])

  return null
}
